import Language from 'constants/language';
export default function isNorwegian(i18nInstance) {
  const currentLanguage = i18nInstance.languages[0];
  return currentLanguage === Language.norwegian || currentLanguage === Language.norwegianBokmal;
}